import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // ★ 速度を2秒に固定したカスタムスクロール
  const scrollToTop = () => {
    const duration = 2000; // 2000ms = 2秒
    const startY = window.pageYOffset;
    const startTime = performance.now();

    // スクロール中、ブラウザ標準の smooth 設定を一時的に無効化する
    const html = document.documentElement;
    const originalStyle = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';

    const step = (currentTime: number) => {
      const progress = currentTime - startTime;
      const percent = Math.min(progress / duration, 1);
      
      // イージング（動き出しと終わりを滑らかにする）
      const easeInOutCubic = percent < 0.5
        ? 4 * percent * percent * percent
        : 1 - Math.pow(-2 * percent + 2, 3) / 2;

      window.scrollTo(0, startY * (1 - easeInOutCubic));

      if (progress < duration) {
        window.requestAnimationFrame(step);
      } else {
        // 完了後に元に戻す
        html.style.scrollBehavior = originalStyle;
      }
    };

    window.requestAnimationFrame(step);
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-8 left-1/2 -translate-x-1/2 z-50 w-10 h-10 flex items-center justify-center rounded-full bg-gray-300/60 hover:bg-gray-300/90 text-gray-500 hover:text-gray-700 transition-all duration-700 ease-in-out cursor-pointer ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      aria-label="Scroll to top"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <i className="ri-arrow-up-s-line ri-lg"></i>
    </button>
  );
}